import { ConfigService,
         MessageEntity,
         MessageOriginEnum,
         AttachmentTypeEnum,
         BotMessageTypeEnum,
         ResponsiveUiHelper }                       from '../../..';

/**
 * The service that implements the functions related to message truncate feature.
 */
export class TruncateMessageService {
  
    /**
     * Indicates whether the MessageTruncate feature has been activated or not.
     */
    public static isMessageTruncateFeatureConfigured(): boolean {
      return (ConfigService.getTruncatePolicy() !== '' && ConfigService.getMaxMessageHeight() > ConfigService.getMinMessageHeight());
    }

    /**
     * Indicates whether the given message could be truncated or not.
     * 
     * @param message - The message to verify if it could be truncated.
     */
    public static canMessageBeTruncated(message: MessageEntity): boolean {
      if (message && message.origin === MessageOriginEnum.USER || message.type === BotMessageTypeEnum.INTRODUCTION) {
          return false;
      }
      if (message && message.attachments !== undefined && message.attachments.size > 0) {
        return (message.attachments.get(AttachmentTypeEnum.BUTTON) === undefined);
      }
      return true;          
    }

    /**
     * Use the maxHeight param and a correction factor to compute the real message's height to return.
     * 
     * @param currentWindowWidth - The width of the container.
     * @param vuetifyRef - The Vuetify plugin reference to get the configured responsive breakpoints.
     */
    public static computeMessageMaxHeight(currentWindowWidth: number, vuetifyRef: any): number {
      const maxHeight: number = ConfigService.getMaxMessageHeight();
      if (maxHeight === -1) {
        return -1; // no maxHeight configured then height shall fit the message box content
      }
      return maxHeight * currentWindowWidth / ResponsiveUiHelper.getCurrentAppliedBreakpointValue(vuetifyRef);
    }
}
